const BaseLayout = ({ children, data }) => (
  <Fragment>
    <SiteMetadata site={data.site.siteMetadata} />
    {children()}
    <Footer data={data.allFooterJson.edges[0].node} />
  </Fragment>
)

export default BaseLayout

/*
 *
 * Imports
 *
 */

import React, { Fragment } from 'react'
import Helmet from 'react-helmet'

import Footer from '../sections/Footer'

/*
 *
 * Global styles
 *
 */

// Use PostCSS stylesheet in development and PostCSS/PurgeCSS stylesheet in production:
switch (process.env.NODE_ENV) {
case `development`:
  require(`../styles/builds/after-postcss/output.css`)
  break
case `production`:
  require(`../styles/builds/after-purgecss/output.css`)
  break
}

// Import open-source fonts from Typefaces (@font-face automatically injected)
import 'typeface-lobster'
import 'typeface-josefin-sans'
import 'typeface-abeezee'

/*
 *
 * Metadata
 *
 */

// This information is populated from gatsby-config.js
// See: https://github.com/nfl/react-helmet + https://megatags.co + https://gethead.info

import siteImage from '../images/favicon.png'

const SiteMetadata = ({ site }) => (
  <Helmet>
    {/* HTML language */}
    <html itemScope itemType="http://schema.org/WebPage" lang={site.language} />

    {/* Title comes first (meta charset and viewport are automatically included) */}
    <title itemProp="name" lang={site.language}>
      {site.title}
    </title>

    {/* Search engine */}
    <meta name="description" content={site.description} />
    <meta name="image" content={site.siteUrl + siteImage} />
    <link rel="canonical" href={site.siteUrl} />

    {/* Schema.org for Google */}
    <meta itemProp="name" content={site.title} />
    <meta itemProp="description" content={site.description} />
    <meta itemProp="image" content={site.siteUrl + siteImage} />

    {/* Twitter */}
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content={site.title} />
    <meta name="twitter:description" content={site.description} />
    {site.twitterHandle && (
      <meta name="twitter:site" content={site.twitterHandle} />
    )}
    <meta name="twitter:image:src" content={site.siteUrl + siteImage} />

    {/* Open Graph general (Facebook, Pinterest, Slack & Google+) */}
    <meta property="og:title" content={site.title} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={site.siteUrl} />
    <meta property="og:image" content={site.siteUrl + siteImage} />
    <meta property="og:description" content={site.description} />
    <meta property="og:site_name" content={site.title} />
    <meta property="og:locale" content={site.locale} />
  </Helmet>
)

/*
 *
 * Queries
 *
 */

export const query = graphql`
  query BaseQuery {
    site {
      siteMetadata {
        description
        language
        locale
        title
        twitterHandle
        siteUrl
      }
    }

    allFooterJson {
      edges {
        node {
          socials {
            site
            link
          }

          sponsors {
            image {
              childImageSharp {
                sizes(maxWidth: 2500) {
                  ...GatsbyImageSharpSizes_withWebp
                }
              }
            }
            alt
            link
          }

          mediaSponsors {
            image {
              childImageSharp {
                sizes(maxWidth: 2500) {
                  ...GatsbyImageSharpSizes_withWebp
                }
              }
            }
            alt
            link
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js